(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button"] && !Shopify.designMode) return;
  try {
    // Force download for cross-origin file links (PDFs, images, etc.)
  document.addEventListener('click', async (e) => {
    const link = e.target.closest('a[data-force-download]');
    if (!link) return;

    e.preventDefault();
    const url = link.href;

    // Extract filename from URL (before query params)
    const urlPath = url.split('?')[0];
    const filename = urlPath.split('/').pop() || 'download';

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const tempLink = document.createElement('a');
      tempLink.href = blobUrl;
      tempLink.download = filename;
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      // Fallback: open in new tab if fetch fails
      window.open(url, '_blank');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
